module.exports = __webpack_public_path__ + "assets/img/fps-img.cc1b0ab6.png";